import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { H2 } from '@r1-frontend/ui-react/components/typography/heading';

import { QuestionsContainer } from '~/src/components/Questions';
import { ITariffLine } from '~/src/entities/tariff-lines';
import PromoBannerBundle from '~/src/features/bundles/components/PromoBannerBundle';
import Filters from '~/src/features/bundles/containers/Filters';
import PromoInfo from '~/src/features/bundles/containers/PromoInfo';
import TariffOffers from '~/src/features/bundles/containers/TariffLineOffers';
import { useRouterChange } from '~/src/helpers/hooks/useRouterChange';
import { TState } from '~/src/store';
import { selectCompanyName } from '~/src/store/selectors/city';

import { PATH_BUNDLES_LINK_CITY, PATH_BUNDLES_LINK_VILLAGE } from '../index/Tariffs/constants';

import * as ST from './styled';

interface IProps {
    tariffLines: ITariffLine[],
    city: ICurrentCity,
    isVillage: boolean,
}

const Bundles = ({ tariffLines, city, isVillage }: IProps) => {
    const [isRouterChanged, nextUrl] = useRouterChange();
    const [isLoading, setIsLoading] = useState(false);
    const bannerInfo = useSelector((state: TState) => state.bundles.banner);
    const companyName = useSelector(selectCompanyName);

    useEffect(() => {
        if (nextUrl === PATH_BUNDLES_LINK_CITY || nextUrl === PATH_BUNDLES_LINK_VILLAGE) {
            setIsLoading(isRouterChanged);
        }
    }, [isRouterChanged, nextUrl]);

    return (
        <ST.Wrapper>
            <ST.StyledGridContainer>
                <ST.TopBlock>
                    <ST.HeadContent>
                        <ST.HeadingWrapper>
                            <ST.OffersInCity>Выберите интернет и цифровое ТВ в {city.cityIn}</ST.OffersInCity>
                            <H2 as={'h1'}>Тарифы {companyName} для {isVillage ? 'частного дома' : 'квартиры'}</H2>
                        </ST.HeadingWrapper>

                        <Filters isVillage={isVillage} isLoading={isLoading}/>
                    </ST.HeadContent>
                    <TariffOffers
                        tariffLines={tariffLines}
                        isVillage={isVillage}
                        isLoading={isLoading}
                    />
                </ST.TopBlock>
                <PromoBannerBundle bannerInfo={bannerInfo} />
                <ST.BottomBlock>
                    <PromoInfo companyName={companyName}/>
                    <QuestionsContainer
                        title={'Если остались вопросы — отвечаем'}
                        statePath={'faq.qaArticles.bundles'}
                        placeAlias='bundles'
                    />
                </ST.BottomBlock>
            </ST.StyledGridContainer>
        </ST.Wrapper>
    );
};

export default Bundles;
